/**
 * Created by pzf on 2018/12/26
 *
 */
import * as React from 'react';
import classNames from 'classnames';

export default class BasicLayout extends React.PureComponent {
  render() {
    const { prefixCls, className, children, ...others } = this.props;
    const divCls = classNames(className, prefixCls);
    return (<div className={divCls} {...others}>{children}</div>);
  }
}